// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1pfhx0bf{margin-block-start:var(--ds-space-negative-100,-8px)}", ""]);
// Exports
module.exports = exports;
